import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function EDSQ() {
  const [activeAccordion, setActiveAccordion] = useState('course-title');
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    💻 DIGITAL SKILLS
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Essential Digital Skills Qualification
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Master essential digital skills for the modern workplace
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="edsq" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Overview */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '2rem' }}>📖</span> Overview
                  </h2>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p>
                      The Essential Digital Skills Qualification (EDSQ) has been designed to meet the content, conditions and requirements set out by the Department for Education (DfE) and Ofqual (in line with the Digital Skills Framework).
                    </p>
                    <p>
                      During your studying, you will develop skills for both work and everyday life to help you develop your digital literacy.
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      The course will provide you with skills such as: using an operating system, installing/removing applications, carrying out web searches, open/read/save files and keeping your details safe online.
                    </p>
                  </div>
                </div>

                {/* Unit Content */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📚</span> Unit Content
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', marginBottom: '25px' }}>
                    Unit content for both Entry Level 3 and Level 1 is:
                  </p>
                  <div className="row g-3">
                    {[
                      { icon: '💻', title: 'Using Devices and Handling', color: '#3b82f6' },
                      { icon: '✏️', title: 'Creating and Editing', color: '#B17ACC' },
                      { icon: '💬', title: 'Communicating', color: '#8b5cf6' },
                      { icon: '🔄', title: 'Transacting', color: '#f59e0b' },
                      { icon: '🔒', title: 'Being Safe and Responsible', color: '#ef4444' }
                    ].map((unit, index) => (
                      <div key={index} className="col-md-6">
                        <div style={{
                          backgroundColor: '#f8fafc',
                          padding: '20px',
                          borderRadius: '12px',
                          border: `2px solid ${unit.color}20`,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '15px'
                        }}>
                          <span style={{ fontSize: '2rem' }}>{unit.icon}</span>
                          <span style={{ 
                            fontSize: '1.05rem', 
                            fontWeight: '600', 
                            color: '#1e293b' 
                          }}>
                            {unit.title}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <p style={{ 
                    fontSize: '1.05rem', 
                    color: '#475569', 
                    marginTop: '25px',
                    marginBottom: 0,
                    fontWeight: '600'
                  }}>
                    By the end of the course, you will have a better understanding of using technology at home and the workplace.
                  </p>
                </div>

                {/* Assessment Methods */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📝</span> Assessment Methods
                  </h3>
                  <p style={{ 
                    fontSize: '1.05rem', 
                    color: '#475569', 
                    lineHeight: '1.8',
                    marginBottom: 0
                  }}>
                    The assessments are on-demand exam based to check understanding of the course content. These are marked based and require supervision.
                  </p>
                </div>

                {/* Progression Options */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#F5EBFA',
                  borderRadius: '24px',
                  border: '2px solid #B17ACC'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#7B3F9E',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>🚀</span> Progression Options
                  </h3>
                  <p style={{ 
                    fontSize: '1.05rem', 
                    color: '#1e293b', 
                    lineHeight: '1.8',
                    marginBottom: 0,
                    fontWeight: '600'
                  }}>
                    Progression option from EDSQ Entry Level 3 will be to EDSQ Level 1.
                  </p>
                </div>

                {/* Course Details Accordion */}
                <div className="shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '25px',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: '700', 
                      marginBottom: 0 
                    }}>
                      Course Details
                    </h4>
                  </div>

                  {/* Accordion Items */}
                  <div>
                    {/* Course Title */}
                    <div style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'course-title' ? '' : 'course-title')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'course-title' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'course-title' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>Course Title</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'course-title' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'course-title' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          Essential Digital Skills Qualification (EDSQ)
                        </div>
                      )}
                    </div>

                    {/* Entry Requirements */}
                    <div style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'entry-req' ? '' : 'entry-req')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'entry-req' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'entry-req' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>Entry Requirements</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'entry-req' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'entry-req' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          Entry requirements for the qualification will be based on an initial assessment which will identify which level to start.
                        </div>
                      )}
                    </div>

                    {/* GLH */}
                    <div>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'glh' ? '' : 'glh')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'glh' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'glh' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>GLH</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'glh' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'glh' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          50 Hours
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default EDSQ;
